import TriggerForm from "./TriggerForm";

export default TriggerForm